

/* @ngInject */ 
export default function($templateCache) {
	var templateString = $templateCache.get('templates/validation/error-tmpl.html');

	return {
		restrict: 'E',
		scope: {
			type: '='
		},
		transclude: true,
		template: templateString,
		link: ErrorLink
	};
}

function ErrorLink() {}
